import "./assets/index.css"
import "./lib/override"

import { createPinia, storeToRefs } from "pinia"
import { createApp } from "vue"
import {
  library,
  config as fontAwesomeConfig,
} from "@fortawesome/fontawesome-svg-core"
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome"
import { ALIcons } from "@af-lib/vue-ui"
import "@af-lib/vue-ui/vue-ui.css"

import { useConfigStore } from "@/stores/config"
import { fetchEnv } from "@/config/api"
import { setDevUsers } from "./config/set-dev-users"
import { globalActor } from "@/machines/globalMachine"

import App from "./App.vue"
import router from "./router"
import icons from "./config/icons"

import { initI18N, i18nPlugin } from "@/plugins/i18n"
import Toast from "vue-toastification"
import { ToastOptions } from "@/plugins/toaster/toastOptions"
import "vue-toastification/dist/index.css"
import mixpanelPlugin from "@/plugins/mixpanel/mixpanel"
import Bugsnag from "@/plugins/bugsnag/bugsnag"
import Datadog from "@/plugins/datadog/datadog"

// Fetch the config.json file
fetchEnv().then(async (config) => {
  const pinia = createPinia()
  const app = createApp(App)
  app.use(pinia)

  const initQueryString = new URLSearchParams(window.location.search)

  // Global and auth store
  const configStore = useConfigStore()
  const { urls } = storeToRefs(configStore)
  configStore.setConfig(config)

  if (initQueryString.get("post-message")) {
    configStore.setPostMessage(initQueryString.get("post-message"))
  }

  // Doit rester AVANT app.use(router) : l'install() de vue-router déclenche la
  // navigation initiale, dont le beforeEach tape l'API. La session dev doit
  // exister avant.
  if (process.env.NODE_ENV === "development" && config.mockMode === "none")
    await setDevUsers()

  app.use(i18nPlugin)
  app.use(mixpanelPlugin)
  app.use(router)
  app.use(Toast, ToastOptions)
  app.use(Bugsnag)
  app.use(Datadog)

  // Fontawesome
  library.add(...icons, ...ALIcons)
  fontAwesomeConfig.autoAddCss = false
  app.component("FaIcon", FontAwesomeIcon)

  await initI18N(urls.value.i18n)

  if (process.env.NODE_ENV === "development") {
    const { exposeDevInspect } = await import("@/config/dev-inspect")
    exposeDevInspect()
  }

  await globalActor.start()
  app.mount("#app")
})
